import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { STORAGE_KEY } from "app/app-constant";
import { AuthService } from "app/core/auth/auth.service";
import { catchError, map, of, switchMap, take, tap, timeout } from "rxjs";

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);

  // Check the authentication status
  return authService.check().pipe(
    switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Redirect to the sign-in page with a redirectUrl param
        const redirectURL =
          state.url === "/sign-out" ? "" : `redirectURL=${state.url}`;
        const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

        return of(urlTree);
      }

      // Keep user configuration fresh, but never allow this convenience call to
      // block protected routes indefinitely on the review server.
      return authService.userConfig().pipe(
        timeout(5000),
        take(1),
        tap((config) => {
          if (config?.data) {
            localStorage.setItem(
              STORAGE_KEY.USER_CONFIG,
              JSON.stringify(config.data)
            );
          }
        }),
        map(() => true),
        catchError(() => of(true))
      );
    })
  );
};
